import React from "react";
import PaypalExpressBtn from "react-paypal-express-checkout";

import { Link } from "react-router-dom";
import ContentLoader from "../../Static/contentLoader";
import Helper from "../../Helper/helper";
import api from "../../../Environment";
import { withToastManager } from "react-toast-notifications";
import ToastDemo from "../../Helper/toaster";

import { translate, t } from "react-multi-lang";
import configuration from "react-global-configuration";
import {
    buildPaymentSuccessConfirmation,
    clearInvoiceCheckoutSession,
    formatMoneyDisplay,
    isPaypalCheckoutVisible,
    loadInvoiceCheckoutSession,
    moneyNumber,
    paymentModeCheckedMap,
    PAYPAL_CHECKOUT_BUTTON_STYLE,
    resolveCheckoutPaymentMode,
    resolveSelectedCardId,
    saveInvoiceCheckoutSession,
    savePaymentSuccessConfirmation,
} from "./checkoutPaymentHelpers";
import "./CheckoutPayment.css";

function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = src
      script.onload = () => {
        resolve(true)
      }
      script.onerror = () => {
        resolve(false)
      }
      document.body.appendChild(script)
    })
}

class InvoiceComponent extends Helper {
    state = {
        loading: true,
        data: {},
        promoCode: null,
        loadingPromoCode: true,
        paymentMode: "card",
        loadingContent: null,
        buttonDisable: false,
        loadingContentCard: null,
        buttonDisableCard: false,
        freeSubscription: false,
        referralData: null,
        loadingReferral: true,
        pay_amount: 0,
        buttonDisableRazorpay: false,
        cards: [],
        cardsLoading: true,
        selectedCardId: null,
        cardActionBusy: false,
    };

    componentDidMount() {
        var locationState =
            this.props.location && this.props.location.state
                ? this.props.location.state
                : null;
        var subscription =
            locationState && locationState.subscription
                ? locationState.subscription
                : null;
        var restored = null;

        if (!subscription) {
            restored = loadInvoiceCheckoutSession();
            if (restored && restored.subscription) {
                subscription = restored.subscription;
            }
        }

        if (!subscription) {
            window.location = "/subscription";
            return;
        }

        var nextState = {
            loading: false,
            pay_amount:
                restored && restored.pay_amount != null
                    ? restored.pay_amount
                    : subscription.amount,
            paymentMode: resolveCheckoutPaymentMode(
                restored && restored.paymentMode,
                isPaypalCheckoutVisible(configuration.get("configData"))
            ),
        };

        if (restored) {
            if (restored.data) {
                nextState.data = restored.data;
            }
            if (restored.promoCode) {
                nextState.promoCode = restored.promoCode;
                nextState.loadingPromoCode = false;
            }
            if (typeof restored.freeSubscription === "boolean") {
                nextState.freeSubscription = restored.freeSubscription;
            }
            if (restored.referralData) {
                nextState.referralData = restored.referralData;
                nextState.loadingReferral = false;
            }
            if (restored.selectedCardId != null) {
                nextState.selectedCardId = restored.selectedCardId;
            }
        }

        this._invoiceSubscription = subscription;
        this.setState(nextState, () => {
            if (
                this.props.history &&
                !(locationState && locationState.subscription)
            ) {
                this.props.history.replace({
                    pathname: "/invoice",
                    state: { subscription: subscription },
                });
            }
            this.checkReferralInvoice();
            this.loadSavedCards();
        });
    }

    getSubscription = () => {
        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.subscription
        ) {
            return this.props.location.state.subscription;
        }
        return this._invoiceSubscription || null;
    };

    persistCheckoutSession = (overrides) => {
        var subscription = this.getSubscription();
        if (!subscription) {
            return;
        }
        saveInvoiceCheckoutSession(
            Object.assign(
                {
                    path: "/invoice",
                    subscription: subscription,
                    paymentMode: this.state.paymentMode || "card",
                    data: this.state.data,
                    promoCode: this.state.promoCode,
                    loadingPromoCode: this.state.loadingPromoCode,
                    pay_amount: this.state.pay_amount,
                    freeSubscription: this.state.freeSubscription,
                    referralData: this.state.referralData,
                    loadingReferral: this.state.loadingReferral,
                    selectedCardId: this.state.selectedCardId,
                },
                overrides || {}
            )
        );
    };

    loadSavedCards = () => {
        this.setState({ cardsLoading: true });
        api
            .postMethod("card_details")
            .then((response) => {
                if (response.data.success) {
                    var cards = response.data.data || [];
                    var selectedCardId = resolveSelectedCardId(
                        cards,
                        this.state.selectedCardId
                    );
                    this.setState({
                        cards: cards,
                        cardsLoading: false,
                        selectedCardId: selectedCardId,
                        paymentMode: this.state.paymentMode || "card",
                    });
                } else {
                    this.setState({
                        cards: [],
                        cardsLoading: false,
                        selectedCardId: null,
                    });
                }
            })
            .catch(() => {
                this.setState({
                    cards: [],
                    cardsLoading: false,
                    selectedCardId: null,
                });
            });
    };

    goToAddCard = (event) => {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        this.persistCheckoutSession({ paymentMode: "card" });
        if (this.props.history) {
            this.props.history.push("/add-card");
        }
    };

    selectSavedCard = (card) => {
        if (!card || this.state.cardActionBusy) {
            return;
        }
        this.setState({
            selectedCardId: card.card_id,
            paymentMode: "card",
        });
        if (card.is_default) {
            return;
        }
        this.setState({ cardActionBusy: true });
        api
            .postMethod("default_card", { card_id: card.card_id })
            .then((response) => {
                if (response.data.success) {
                    this.loadSavedCards();
                } else {
                    ToastDemo(
                        this.props.toastManager,
                        response.data.error_messages,
                        "error"
                    );
                }
            })
            .catch((error) => {
                ToastDemo(this.props.toastManager, error, "error");
            })
            .then(() => {
                this.setState({ cardActionBusy: false });
            });
    };

    checkReferralInvoice = event => {
        var subscription = this.getSubscription();
        if (!subscription) {
            return;
        }
        let inputData = {
            amount: subscription.amount
        };
        api.postMethod("invoice_referral_amount", inputData)
            .then(response => {
                if (response.data.success) {
                    var referralPay = response.data.data.pay_amount;
                    var keepPromoTotal = !this.state.loadingPromoCode;
                    var patch = {
                        referralData: response.data.data,
                        loadingReferral: false
                    };
                    if (!keepPromoTotal) {
                        patch.pay_amount = referralPay;
                        if (referralPay <= 0) {
                            patch.freeSubscription = true;
                        }
                    }
                    this.setState(patch);
                } else {
                    ToastDemo(
                        this.props.toastManager,
                        response.data.error_messages,
                        "error"
                    );
                    this.setState({
                        loadingContent: null,
                        buttonDisable: false,
                        loadingReferral: false
                    });
                }
            })
            .catch(error => {
                this.setState({ loadingReferral: false });
            });
    };

    handlePromoCode = event => {
        event.preventDefault();
        var subscription = this.getSubscription();
        if (!subscription) {
            return;
        }
        this.setState({
            loadingContent: t("loading_text"),
            buttonDisable: true
        });
        let inputData = {
            coupon_code: this.state.data.coupon_code,
            subscription_id: subscription.subscription_id
        };
        api.postMethod("apply/coupon/subscription", inputData)
            .then(response => {
                if (response.data.success) {
                    ToastDemo(
                        this.props.toastManager,
                        t("promo_code_applied_success"),
                        "success"
                    );
                    this.setState({
                        loadingContent: null,
                        buttonDisable: false,
                        loadingPromoCode: false,
                        promoCode: response.data.data,
                        freeSubscription:
                            response.data.data.remaining_amount <= 0,
                        pay_amount: response.data.data.remaining_amount
                    });
                } else {
                    ToastDemo(
                        this.props.toastManager,
                        response.data.error_messages,
                        "error"
                    );
                    this.setState({
                        loadingContent: null,
                        buttonDisable: false
                    });
                }
            })
            .catch(error => {
                ToastDemo(this.props.toastManager, error, "error");
                this.setState({ loadingContent: null, buttonDisable: false });
            });
    };

    handlePromoCodeCancel = event => {
        event.preventDefault();
        var subscription = this.getSubscription();
        var restoredAmount =
            this.state.referralData &&
            this.state.referralData.pay_amount != null
                ? this.state.referralData.pay_amount
                : subscription
                ? subscription.amount
                : 0;
        this.setState({
            promoCode: null,
            loadingPromoCode: true,
            pay_amount: restoredAmount,
            freeSubscription: Number(restoredAmount) <= 0
        });
        ToastDemo(this.props.toastManager, t("promo_code_removed"), "error");
    };

    handleChangePayment = ({ currentTarget: input }) => {
        var nextMode = input.value;
        this.setState({ paymentMode: nextMode }, () => {
            this.persistCheckoutSession({ paymentMode: nextMode });
        });
    };

    handlePayment = event => {
        event.preventDefault();
        var subscription = this.getSubscription();
        if (!subscription) {
            ToastDemo(
                this.props.toastManager,
                "Subscription missing. Return to plans and try again.",
                "error"
            );
            return;
        }

        if (
            this.state.paymentMode === "card" &&
            !this.state.freeSubscription &&
            Number(this.state.pay_amount) > 0
        ) {
            if (!this.state.selectedCardId) {
                ToastDemo(
                    this.props.toastManager,
                    "Please add a card before paying.",
                    "error"
                );
                return;
            }
        }

        this.setState({
            loadingContentCard: t("loading_text"),
            buttonDisableCard: true
        });
        let inputData;
        if (this.state.promoCode == null) {
            inputData = {
                subscription_id: subscription.subscription_id,
                payment_mode: this.state.paymentMode
            };
        } else {
            inputData = {
                coupon_code: this.state.data.coupon_code,
                subscription_id: subscription.subscription_id,
                payment_mode: this.state.paymentMode
            };
        }
        if(this.state.paymentMode == "razorpay") {
            this.displayRazorpay(inputData);
        } else if (this.state.paymentMode == "paystack") {
            this.paymentPayStackApiCall(inputData);

        }else {
            this.paymentApiCall(inputData);
        }
        
    };

    paymentPayStackApiCall = (inputData) => {
        api.postMethod("subscriptions_payment_by_paystack", inputData)
        .then((response) => {
            if (response.data.success) {
                ToastDemo(this.props.toastManager, response.data.message, "success");
                clearInvoiceCheckoutSession();
                this.setState({
                    loadingContentCard: null,
                    buttonDisableCard: false,
                });
                if (response.data.data.authorization_url) {
                    window.location.href = response.data.data.authorization_url;
                } else {
                    this.props.history.push("/billing-details");
                }
            } else {
                ToastDemo(
                    this.props.toastManager,
                    response.data.error_messages,
                    "error"
                );
                this.setState({
                    loadingContentCard: null,
                    buttonDisableCard: false,
                });
            }
        })
        .catch((error) => {
            ToastDemo(this.props.toastManager, error, "error");
            this.setState({
            loadingContentCard: null,
            buttonDisableCard: false,
            });
        });
    };

    displayRazorpay = async (inputData) => {

        const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')
    
        if (!res) {
            alert('Razorpay SDK failed to load. Are you online?')
            this.setState({
                loadingContentCard: null,
                buttonDisableCard: false,
            });
            return
        }
    
        const data = await api.postMethod("subscription_razorpay_create_order", inputData).then(res => res.data);
        if (data.success) {
            const options = {
                key: configuration.get("configData.RAZOR_KEY"),
                currency: data.data.currency,
                amount: data.data.amount.toString(),
                order_id: data.data.id,
                name: 'Subscription Payment',
                description: 'Subscription Payment',
                handler: async (response) => {
                    try {
                        const payment_id = response.razorpay_payment_id;
                        inputData = { ...inputData, payment_id }
                        this.paymentApiCall(inputData);
                    } catch (err) {
                        ToastDemo(
                            this.props.toastManager,
                            err && err.message ? err.message : "Payment error",
                            "error"
                        );
                        this.setState({
                            loadingContentCard: null,
                            buttonDisableCard: false,
                        });
                    }
                }
            }
            const paymentObject = new window.Razorpay(options)
            paymentObject.open()
            this.setState({
                loadingContentCard: null,
                buttonDisableCard: false,
            });
        } else {
            ToastDemo(
                this.props.toastManager,
                data.error,
                "error"
            );
            this.setState({
                loadingContentCard: null,
                buttonDisableCard: false,
            });
        }
        
    }

    paymentApiCall = inputData => {
        // BE contract (9c7cd6ad): POST userApi/v4/subscriptions_payment
        // card mode charges the user's default saved card — no card_id in body.
        // Card + PayPal both share this success path → /payment-success.
        api.postMethod("v4/subscriptions_payment", inputData)
            .then(response => {
                if (response.data.success) {
                    var subscription = this.getSubscription() || {};
                    var confirmation = buildPaymentSuccessConfirmation(
                        response.data,
                        {
                            title: subscription.title,
                            plan_formatted: subscription.plan_formatted,
                            currency: subscription.currency,
                            amount: this.state.pay_amount,
                        }
                    );
                    // Capture confirmation before clearing checkout session.
                    savePaymentSuccessConfirmation(confirmation);
                    clearInvoiceCheckoutSession();
                    this.setState({
                        loadingContentCard: null,
                        buttonDisableCard: false
                    });
                    this.props.history.push({
                        pathname: "/payment-success",
                        state: { paymentSuccess: confirmation },
                    });
                } else {
                    ToastDemo(
                        this.props.toastManager,
                        response.data.error_messages,
                        "error"
                    );
                    this.setState({
                        loadingContentCard: null,
                        buttonDisableCard: false
                    });
                }
            })
            .catch(error => {
                ToastDemo(this.props.toastManager, error, "error");
                this.setState({
                    loadingContentCard: null,
                    buttonDisableCard: false
                });
            });
    };

    render() {
        const { t } = this.props;

        if (this.state.loading) {
            return <ContentLoader />;
        } else {
            var invoiceImg = {
                backgroundImage: "url(../assets/img/invoice.gif)"
            };
            const subscription = this.getSubscription();
            if (!subscription) {
                return <ContentLoader />;
            }
            const {
                data,
                loadingPromoCode,
                promoCode,
                paymentMode,
                cards,
                cardsLoading,
                selectedCardId
            } = this.state;
            const modeChecked = paymentModeCheckedMap(paymentMode);
            const paypalVisible = isPaypalCheckoutVisible(
                configuration.get("configData")
            );

            const onSuccess = payment => {
                let inputData;
                if (this.state.promoCode == null) {
                    inputData = {
                        subscription_id: subscription.subscription_id,
                        payment_mode: this.state.paymentMode,
                        payment_id: payment.paymentID
                    };
                } else {
                    inputData = {
                        coupon_code: this.state.data.coupon_code,
                        subscription_id: subscription.subscription_id,
                        payment_mode: this.state.paymentMode,
                        payment_id: payment.paymentID
                    };
                }
                this.paymentApiCall(inputData);
            };

            const onCancel = data => {
                // User closed PayPal popup — no-op
            };

            const onError = err => {
                ToastDemo(
                    this.props.toastManager,
                    err && err.message ? err.message : "PayPal error",
                    "error"
                );
            };

            let env = configuration.get("configData.PAYPAL_MODE");
            let currency = "USD";
            let total = moneyNumber(
                loadingPromoCode
                    ? this.state.pay_amount
                    : promoCode.remaining_amount
            );

            const client = {
                sandbox: configuration.get("configData.PAYPAL_ID"),
                production: configuration.get("configData.PAYPAL_ID")
            };

            return (
                <div>
                    <div className="main padding-top-md">
                        <div className="top-bottom-spacing">
                            <div className="row">
                                <div className="col-sm-10 col-md-8 col-lg-7 col-xl-6 auto-margin">
                                    <div
                                        style={invoiceImg}
                                        className="invoice-img"
                                    >
                                        <h1>{t("invoice")}</h1>
                                    </div>
                                    <div className="payment-option">
                                        <h4 className="billing-head">
                                            <i className="far fa-file mr-2" />
                                            {subscription.title}
                                        </h4>
                                        <p className="grey-line" />
                                        <div className="">
                                            <p className="grey-clr pay-perview-text">
                                                {subscription.description}
                                            </p>
                                            <h5 className="">
                                                {t("no_of_accounts")} -{" "}
                                                {subscription.no_of_account}
                                            </h5>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table white-bg m-0 mt-3">
                                                <tbody>
                                                    <tr className="table-secondary">
                                                        <td>{t("amount")}</td>
                                                        <td>
                                                            {formatMoneyDisplay(
                                                                subscription.currency,
                                                                subscription.amount
                                                            )}
                                                        </td>
                                                    </tr>
                                                    {subscription.amount > 0 ? (
                                                        <tr>
                                                            <td>
                                                                {t(
                                                                    "promo_code_amount"
                                                                )}
                                                            </td>
                                                            <td>
                                                                {formatMoneyDisplay(
                                                                    subscription.currency,
                                                                    loadingPromoCode
                                                                        ? 0
                                                                        : promoCode.coupon_amount
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {!this.state
                                                        .loadingReferral ? (
                                                        this.state.referralData
                                                            .referral_amount >
                                                        0 ? (
                                                            <tr>
                                                                <td>
                                                                    {t(
                                                                        "referral_amount_applied"
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {
                                                                        this
                                                                            .state
                                                                            .referralData
                                                                            .referral_amount_formatted
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            ""
                                                        )
                                                    ) : (
                                                        ""
                                                    )}
                                                    <tr className="table-secondary">
                                                        <td>{t("total")}</td>
                                                        <td>
                                                            {formatMoneyDisplay(
                                                                subscription.currency,
                                                                this.state
                                                                    .pay_amount
                                                            )}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {subscription.amount > 0 &&
                                        !this.state.freeSubscription ? (
                                            <div className="mt-4">
                                                <h5 className="capitalize">
                                                    {t("have_a_coupon")}
                                                </h5>
                                                <form
                                                    className="auth-form"
                                                    onSubmit={
                                                        this.handlePromoCode
                                                    }
                                                >
                                                    <div className="form-group mt-3">
                                                        <div className="input-group mb-3 mt-1">
                                                            <input
                                                                type="text"
                                                                className="form-control m-0 mb-0"
                                                                placeholder="promo code"
                                                                name="coupon_code"
                                                                value={
                                                                    data.coupon_code ||
                                                                    ""
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                            />
                                                            <div className="input-group-append">
                                                                <button
                                                                    className="btn btn-danger"
                                                                    type="submit"
                                                                >
                                                                    {this.state
                                                                        .loadingContent !=
                                                                    null
                                                                        ? this
                                                                              .state
                                                                              .loadingContent
                                                                        : t(
                                                                              "send"
                                                                          )}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                                {loadingPromoCode ? (
                                                    ""
                                                ) : (
                                                    <p className="capitalize">
                                                        {t(
                                                            "promo_code_applied"
                                                        )}{" "}
                                                        -{" "}
                                                        {promoCode.coupon_code}{" "}
                                                        for{" "}
                                                        {
                                                            promoCode.original_coupon_amount
                                                        }{" "}
                                                        -{" "}
                                                        <Link
                                                            to="#"
                                                            className="btn btn-outline-danger"
                                                            onClick={
                                                                this
                                                                    .handlePromoCodeCancel
                                                            }
                                                        >
                                                            {t("remove")}
                                                        </Link>
                                                    </p>
                                                )}
                                            </div>
                                        ) : (
                                            ""
                                        )}

                                        <div className="mt-4 checkout-payment-methods">
                                            <form
                                                className="mt-3"
                                                onSubmit={(e) =>
                                                    e.preventDefault()
                                                }
                                            >
                                                {subscription.amount > 0 &&
                                                this.state.freeSubscription ==
                                                    false ? (
                                                    <div>
                                                        <h5 className="capitalize">
                                                            {t(
                                                                "choose_payment_option"
                                                            )}
                                                        </h5>
                                                        <div className="checkout-payment-methods__choices">
                                                        {paypalVisible &&
                                                        configuration.get(
                                                            "configData.PAYPAL_ID"
                                                        ) ? (
                                                            <div className="checkout-payment-methods__choice form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="paypal"
                                                                    name="payment_mode"
                                                                    value="paypal"
                                                                    checked={
                                                                        !!modeChecked.paypal
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .handleChangePayment
                                                                    }
                                                                />
                                                                <label htmlFor="paypal">
                                                                    {t(
                                                                        "paypal"
                                                                    )}
                                                                </label>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {configuration.get("configData.is_razorpay_enabled") == 1 ? (
                                                            <div className="checkout-payment-methods__choice form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="razorpay"
                                                                    name="payment_mode"
                                                                    value="razorpay"
                                                                    checked={
                                                                        !!modeChecked.razorpay
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .handleChangePayment
                                                                    }
                                                                />
                                                                <label htmlFor="razorpay">
                                                                    {t(
                                                                        "razorpay"
                                                                    )}
                                                                </label>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {configuration.get("configData.is_paystack_enabled") == 1 ? (
                                                            <div className="checkout-payment-methods__choice form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="paystack"
                                                                    name="payment_mode"
                                                                    value="paystack"
                                                                    checked={
                                                                        !!modeChecked.paystack
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .handleChangePayment
                                                                    }
                                                                />
                                                                <label htmlFor="paystack">
                                                                    {t(
                                                                        "paystack"
                                                                    )}
                                                                </label>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <div className="checkout-payment-methods__choice form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="card"
                                                                name="payment_mode"
                                                                value="card"
                                                                checked={
                                                                    !!modeChecked.card
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChangePayment
                                                                }
                                                            />
                                                            <label htmlFor="card">
                                                                {t(
                                                                    "card_payment"
                                                                )}
                                                            </label>
                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="btn btn-link checkout-payment-methods__add-card p-0"
                                                            onClick={
                                                                this.goToAddCard
                                                            }
                                                        >
                                                            {t("add")}{" "}
                                                            {t("card")}
                                                        </button>
                                                        </div>

                                                        {paymentMode ===
                                                        "card" ? (
                                                            <div className="checkout-payment-methods__cards">
                                                                {cardsLoading ? (
                                                                    <p className="checkout-payment-methods__hint m-0">
                                                                        Loading
                                                                        saved
                                                                        cards…
                                                                    </p>
                                                                ) : cards.length ===
                                                                  0 ? (
                                                                    <p className="checkout-payment-methods__hint m-0">
                                                                        No saved
                                                                        card yet.
                                                                        Use Add
                                                                        Card,
                                                                        then
                                                                        return
                                                                        here to
                                                                        pay.
                                                                    </p>
                                                                ) : (
                                                                    cards.map(
                                                                        (
                                                                            card
                                                                        ) => (
                                                                            <label
                                                                                key={
                                                                                    card.card_id
                                                                                }
                                                                                className="checkout-payment-methods__card-row"
                                                                            >
                                                                                <input
                                                                                    type="radio"
                                                                                    name="saved_card"
                                                                                    value={
                                                                                        card.card_id
                                                                                    }
                                                                                    checked={
                                                                                        String(
                                                                                            selectedCardId
                                                                                        ) ===
                                                                                        String(
                                                                                            card.card_id
                                                                                        )
                                                                                    }
                                                                                    onChange={() =>
                                                                                        this.selectSavedCard(
                                                                                            card
                                                                                        )
                                                                                    }
                                                                                />
                                                                                <span className="checkout-payment-methods__card-meta">
                                                                                    XXXX
                                                                                    XXXX
                                                                                    XXXX{" "}
                                                                                    {
                                                                                        card.last_four
                                                                                    }
                                                                                    {card.is_default ? (
                                                                                        <span className="green-clr">
                                                                                            {t(
                                                                                                "card_default"
                                                                                            )}
                                                                                        </span>
                                                                                    ) : null}
                                                                                </span>
                                                                            </label>
                                                                        )
                                                                    )
                                                                )}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                ) : (
                                                    ""
                                                )}

                                                <div className="checkout-payment-methods__actions text-right mb-3 mt-3">
                                                    {paymentMode == "card" ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={
                                                                this
                                                                    .handlePayment
                                                            }
                                                            disabled={
                                                                this.state
                                                                    .buttonDisableCard ||
                                                                (Number(
                                                                    this.state
                                                                        .pay_amount
                                                                ) > 0 &&
                                                                    !this.state
                                                                        .freeSubscription &&
                                                                    !this.state
                                                                        .selectedCardId)
                                                            }
                                                        >
                                                            {this.state
                                                                .freeSubscription ==
                                                            false
                                                                ? this.state
                                                                      .loadingContentCard !=
                                                                  null
                                                                    ? this.state
                                                                          .loadingContentCard
                                                                    : subscription.amount >
                                                                      0
                                                                    ? t(
                                                                          "pay_now_using_card"
                                                                      )
                                                                    : t(
                                                                          "subscribe_now"
                                                                      )
                                                                : t(
                                                                      "subscribe_now"
                                                                  )}
                                                        </button>
                                                    ) : paymentMode === "paypal" &&
                                                      paypalVisible ? (
                                                        <div className="checkout-payment-methods__paypal">
                                                            <PaypalExpressBtn
                                                                env={env}
                                                                client={client}
                                                                currency={currency}
                                                                total={total}
                                                                style={
                                                                    PAYPAL_CHECKOUT_BUTTON_STYLE
                                                                }
                                                                onError={onError}
                                                                onSuccess={
                                                                    onSuccess
                                                                }
                                                                onCancel={onCancel}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={
                                                                this
                                                                    .handlePayment
                                                            }
                                                            disabled={
                                                                this.state
                                                                    .buttonDisableCard
                                                            }
                                                        >
                                                            {t("pay_now")}
                                                        </button> 
                                                    )}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default withToastManager(translate(InvoiceComponent));
